module.exports = __webpack_public_path__ + "static/media/logo-fast@2x.bebc41e9.png";